var header_menu = $('.header__menu'),
    header_phone_wrapper = $('.header-phone-wrapper'),
    header_mobile_menu = header_phone_wrapper.find('.header__phone-menu'),
    header_line = header_menu.find('.menu__line'),
    current_href = location.pathname;

function clearInitialFocus() {
    window.requestAnimationFrame(function () {
        var activeElement = document.activeElement;

        if (activeElement && activeElement !== document.body && activeElement !== document.documentElement) {
            activeElement.blur();
        }
    });
}

clearInitialFocus();
window.addEventListener('pageshow', clearInitialFocus);

new WOW().init();

function headerLineInit() {
    var current_path = current_href.split('/')[1];
    var _this = header_menu.find('a[href="/' + current_path + '"]').find('.menu__item:not(.topup)'),
        _this_mobile = header_mobile_menu.find('a[href="/' + current_path + '"]').find('.menu__item:not(.topup)');

    if (!_this.length || !_this_mobile.length) return false;

    var _this_width = _this.width(),
        _this_left = _this.position().left;

    header_line.css('width', _this_width);
    header_line.css('left', _this_left);
    _this.addClass('active');
    _this_mobile.addClass('active');
}

headerLineInit();

header_menu.find('.menu__item:not(.topup)').on('mouseenter', function () {
    var _this = $(this),
        _this_width = _this.width(),
        _this_left = _this.position().left;

    header_line.css('width', _this_width);
    header_line.css('left', _this_left);
});

$('.header-wrapper').on('mouseleave', function () {
    headerLineInit();
});

$('.header #menu-toggle').on('click', function () {
    let _this = $(this);

    if (_this.is(':checked')) {
        header_phone_wrapper.fadeIn(250);
    } else {
        header_phone_wrapper.fadeOut(250);
    }
});

var headerSocialMenu = $('.js-header-social-menu');

if (headerSocialMenu.length) {
    var headerSocialToggle = headerSocialMenu.find('.js-header-social-menu-toggle');

    var closeHeaderSocialMenu = function () {
        headerSocialMenu.removeClass('is-open');
        headerSocialToggle.attr('aria-expanded', 'false');
        headerSocialToggle.attr('aria-label', 'Open social links');
    };

    headerSocialToggle.on('click', function (event) {
        var shouldOpen;

        event.preventDefault();
        event.stopPropagation();

        shouldOpen = !headerSocialMenu.hasClass('is-open');

        if (shouldOpen) {
            headerSocialMenu.addClass('is-open');
            headerSocialToggle.attr('aria-expanded', 'true');
            headerSocialToggle.attr('aria-label', 'Close social links');
        } else {
            closeHeaderSocialMenu();
        }
    });

    $(document).on('click', function (event) {
        if (!$(event.target).closest('.js-header-social-menu').length) {
            closeHeaderSocialMenu();
        }
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') {
            closeHeaderSocialMenu();
        }
    });
}

$('.jsselect2').select2({
    minimumResultsForSearch: -1,
    dropdownAutoWidth: true,
});

var scene = document.getElementById('parallax');
if (scene != null) {
    var parallaxInstance = new Parallax(scene, {
        relativeInput: true,
        selector: '.parallax',
    });
}

var languageSwitchers = $('.js-language-switcher');

if (languageSwitchers.length) {
    var closeLanguageSwitchers = function () {
        languageSwitchers.removeClass('is-open');
        languageSwitchers.find('.js-language-switcher-toggle').attr('aria-expanded', 'false');
    };

    languageSwitchers.each(function () {
        var switcher = $(this),
            trigger = switcher.find('.js-language-switcher-toggle');

        trigger.on('click', function (event) {
            var shouldOpen;

            event.preventDefault();
            event.stopPropagation();

            shouldOpen = !switcher.hasClass('is-open');
            closeLanguageSwitchers();

            if (shouldOpen) {
                switcher.addClass('is-open');
                trigger.attr('aria-expanded', 'true');
            }
        });
    });

    $(document).on('click', function (event) {
        if (!$(event.target).closest('.js-language-switcher').length) {
            closeLanguageSwitchers();
        }
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') {
            closeLanguageSwitchers();
        }
    });
}

var regionLanguageSwitchers = $('.js-region-language-switcher');

if (regionLanguageSwitchers.length) {
    var mobileMedia = window.matchMedia('(orientation: portrait), (max-width: 980px)');

    var setRegionLanguageModalHeight = function () {
        var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;

        if (viewportHeight) {
            document.documentElement.style.setProperty('--region-language-modal-height', viewportHeight + 'px');
        }
    };

    var setStpWidgetLocale = function (lang, region) {
        var widgetScript;

        if (!lang && !region) return;

        widgetScript = document.querySelector('script[src*="stp-widget.js"]');
        if (!widgetScript) return;

        if (lang) widgetScript.setAttribute('data-lang', lang);
        if (region) widgetScript.setAttribute('data-region', region);
    };

    var closeRegionLanguageSwitchers = function () {
        regionLanguageSwitchers.removeClass('is-open');
        regionLanguageSwitchers.find('.js-region-language-switcher-toggle').attr('aria-expanded', 'false');
        $('.region-language-switcher__modal').removeClass('is-open');
        $('body').removeClass('region-language-modal-open');
    };

    var isMobileRegionLanguage = function (switcher) {
        return switcher.hasClass('region-language-switcher--mobile') && mobileMedia.matches;
    };

    var getRegionLanguageOptionUrl = function (optionScope, dataName, value) {
        var option;

        if (!value) return '';

        option = optionScope.find('.region-language-switcher__option[data-' + dataName + '="' + value + '"]').first();

        return option.length ? option.attr('href') : '';
    };

    var getRegionLanguageTargetUrl = function (optionScope, urlMap, region, lang, currentRegion, currentLang) {
        var targetUrl = urlMap && urlMap[region] && urlMap[region][lang] ? urlMap[region][lang] : '';

        if (targetUrl) return targetUrl;

        if (lang && (!region || region === currentRegion)) {
            targetUrl = getRegionLanguageOptionUrl(optionScope, 'lang', lang);
        }

        if (targetUrl) return targetUrl;

        if (region && (!lang || lang === currentLang)) {
            targetUrl = getRegionLanguageOptionUrl(optionScope, 'region', region);
        }

        return targetUrl;
    };

    setRegionLanguageModalHeight();

    $(window).on('resize orientationchange', setRegionLanguageModalHeight);

    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', setRegionLanguageModalHeight);
    }

    regionLanguageSwitchers.each(function () {
        var switcher = $(this),
            trigger = switcher.find('.js-region-language-switcher-toggle'),
            modal = switcher.find('.region-language-switcher__modal'),
            optionScope,
            currentRegion = switcher.data('current-region'),
            currentLang = switcher.data('current-lang'),
            selectedRegion = currentRegion,
            selectedLang = currentLang,
            urlMap = switcher.data('url-map') || {};

        if (switcher.hasClass('region-language-switcher--mobile') && modal.length) {
            modal.appendTo(document.body);
        }

        optionScope = switcher.add(modal);
        selectedRegion = selectedRegion || optionScope.find('.region-language-switcher__option[data-region].is-active').first().data('region');
        selectedLang = selectedLang || optionScope.find('.region-language-switcher__option[data-lang].is-active').first().data('lang');

        trigger.on('click', function (event) {
            var shouldOpen;

            event.preventDefault();
            event.stopPropagation();

            shouldOpen = !switcher.hasClass('is-open');
            closeRegionLanguageSwitchers();

            if (shouldOpen) {
                switcher.addClass('is-open');
                trigger.attr('aria-expanded', 'true');

                if (isMobileRegionLanguage(switcher)) {
                    setRegionLanguageModalHeight();
                    modal.addClass('is-open');
                    $('body').addClass('region-language-modal-open');
                }
            }
        });

        optionScope.find('.region-language-switcher__option').on('click', function (event) {
            var option = $(this),
                optionLang = option.data('lang'),
                optionRegion = option.data('region'),
                section = option.closest('.region-language-switcher__section');

            if (!isMobileRegionLanguage(switcher)) {
                setStpWidgetLocale(optionLang, optionRegion);

                if (option.hasClass('is-active')) {
                    event.preventDefault();
                    closeRegionLanguageSwitchers();
                }

                return;
            }

            event.preventDefault();

            if (optionRegion) {
                selectedRegion = optionRegion;
            }

            if (optionLang) {
                selectedLang = optionLang;
            }

            setStpWidgetLocale(optionLang, optionRegion);

            section.find('.region-language-switcher__option').removeClass('is-active');
            option.addClass('is-active');
        });

        optionScope.find('.js-region-language-switcher-apply').on('click', function () {
            var targetUrl = getRegionLanguageTargetUrl(optionScope, urlMap, selectedRegion, selectedLang, currentRegion, currentLang);

            if (targetUrl) {
                window.location.href = targetUrl;
            } else {
                closeRegionLanguageSwitchers();
            }
        });

        modal.on('click', function (event) {
            if (event.target === this) {
                closeRegionLanguageSwitchers();
            }
        });
    });

    $(document).on('click', function (event) {
        if (!$(event.target).closest('.js-region-language-switcher').length && !$(event.target).closest('.region-language-switcher__modal').length) {
            closeRegionLanguageSwitchers();
        }
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') {
            closeRegionLanguageSwitchers();
        }
    });
}
